<ng-template #popoverContent>
  <mat-icon class="close-mat-icon" (click)="p.close()">close</mat-icon>
  <ngb-timepicker [(ngModel)]="time"></ngb-timepicker>
</ng-template>
<div [ngStyle]="{'display': 'flex'}">
  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="time-form-field">
    <input matInput #input placeholder="0:0" (keyup)="updateTime($event)" maxlength="5" autocomplete="off" (blur)="popOverClose()"/>
    <button
      type="button" mat-icon-button aria-label="close" class="btn btn-outline-secondary" [popoverTitle]="" #p="ngbPopover"
      [autoClose]="'outside'" [ngbPopover]="popoverContent" placement="bottom" (document:click)="OnChanges($event, time)"
      (hidden)="popOverClose()"
    >
      <mat-icon class="timer-icon">schedule</mat-icon>
    </button>
  </mat-form-field>
</div>
